// extracted by mini-css-extract-plugin
module.exports = {"title":"AdminCreate_title__odHEP"};